.pad {
  position: relative;
  display: grid;
  flex-shrink: 0;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;
  gap: 1em 1em;
  height: 32em;
  width: 25em;
  background-color: light-dark(var(--mantine-color-gray-4), var(--mantine-color-dark-4));
  padding: 5em 1em 5em;
  --corner-cut-size: 4em;
  clip-path: polygon(
    var(--corner-cut-size) 0,
    calc(100% - var(--corner-cut-size)) 0,
    100% var(--corner-cut-size),
    100% calc(100% - var(--corner-cut-size)),
    calc(100% - var(--corner-cut-size)) 100%,
    var(--corner-cut-size) 100%,
    0 calc(100% - var(--corner-cut-size)),
    0 var(--corner-cut-size)
  );
}
.pad::after {
  /* its a bar! */
  content: "";
  text-align: center;
  height: 1em;
  width: 60%;
  background-color: light-dark(#222, #111);
  border-radius: 1em;
  position: absolute;
  bottom: 1.5em;
  left: 20%;
}
.pad.disabled {
  opacity: 0.5;
}

.panel {
  box-sizing: border-box;
  border: 2px solid light-dark(var(--mantine-color-gray-5), var(--mantine-color-dark-3));
  background-color: light-dark(var(--mantine-color-gray-1), var(--mantine-color-dark-6));
  position: relative;
  cursor: pointer;
  display: flex;
  place-items: center;
  justify-content: center;
}
.panel.disabled {
  border-style: dashed;
  background-image: repeating-linear-gradient(
    -45deg,
    light-dark(var(--mantine-color-gray-3), var(--mantine-color-dark-5)),
    light-dark(var(--mantine-color-gray-3), var(--mantine-color-dark-5)) 10px,
    light-dark(var(--mantine-color-gray-1), var(--mantine-color-dark-6)) 10px,
    light-dark(var(--mantine-color-gray-1), var(--mantine-color-dark-6)) 20px
  );
}
.panel.disabled:hover {
  background-color: light-dark(var(--mantine-color-gray-3), var(--mantine-color-dark-5));
  border-color: light-dark(var(--mantine-color-gray-6), var(--mantine-color-dark-2));
}
.panel:not(.disabled):hover {
  background-color: light-dark(var(--mantine-color-gray-3), var(--mantine-color-dark-5));
  border-color: light-dark(var(--mantine-color-gray-6), var(--mantine-color-dark-2));
}
.panel.active {
  background-color: light-dark(var(--mantine-color-green-2), var(--mantine-color-green-9));
  border-color: light-dark(var(--mantine-color-green-7), var(--mantine-color-green-4));
}
.panel.active:hover {
  background-color: light-dark(var(--mantine-color-green-4), var(--mantine-color-green-8));
  border-color: light-dark(var(--mantine-color-green-6), var(--mantine-color-green-3));
}
.panel.commErr {
  background-color: var(--mantine-color-error);
}

.panel:focus-visible {
  outline: 2px solid var(--mantine-primary-color-filled);
  outline-offset: 1px;
}

.fsr,
.loadCell {
  position: absolute;
  font-family: monospace;
}

.sensorDisabled {
  color: light-dark(var(--mantine-color-gray-5), var(--mantine-color-dark-2));
}

.top {
  top: 0;
}
.left {
  left: 0.2em;
}
.right {
  right: 0.2em;
}
.bottom {
  bottom: 0;
}

.fsr.vert {
  top: 50%;
  margin-top: -0.75em;
}
.fsr.horiz {
  width: 100%;
  text-align: center;
  /* margin-left: 0.5em; */
}
